import { action, toJS, makeObservable } from 'mobx';
import { setValues } from './general';
import _pick from 'lodash/pick';
import _omit from 'lodash/omit';
import _difference from 'lodash/difference';

/**
 * Base class used for in global state to store filters of list
 */
export default class BaseFilters {
    initialState = {
        sortDirection: 'ASC',
        skip: 0,
        limit: 25
    };

    constructor() {
        makeObservable(this, {
            setValues: action.bound,
            getPureFilters: action.bound,
            getFiltersNames: action.bound,
            setFilters: action.bound
        });
    }

    /**
     * Batch setter of class properties
     * @param  {Object} valuesToSet={} Object to be merged into
     */
    setValues(valuesToSet = {}) {
        return setValues(this, valuesToSet);
    }

    /**
     * Recursively converts an (observable) object to a javascript structure.
     */
    getPureFilters() {
        return _omit(toJS(this), ['initialState']);
    }

    /**
     * Get names of observable filter properties
     */
    getFiltersNames() {
        return _difference(Object.keys(this), ['initialState']);
    }

    /**
     * Set filters
     * @param  {Object}     filters             State properties to be modified
     * @param  {Boolean}    setInitialValues    Whether to merge initial values with passed filters
     * @return {Boolean}                        Was any of filter values modified ?
     */
    setFilters(filters = {}, setInitialValues = false) {
        // Update only filters
        let filtersToSet = { ..._pick(filters, this.getFiltersNames()) };

        // If requested, set initial filters as base for filters
        if (setInitialValues) filtersToSet = { ...this.initialState, ...filtersToSet };

        return this.setValues(filtersToSet);
    }

    /**
     * Get initial filters
     */
    getInitialFilters() {
        return { ...this.initialState };
    }
}
